const PROD_API_BASE = 'https://oberoi-ai-proxy.vercel.app';
const PROD_TAVILY_PROXY = 'https://oberoi-tavily-proxy.vercel.app';

function resolveApiBase(envValue, prodDefault) {
  const trimmed = (envValue || '').trim();
  if (trimmed) return trimmed.replace(/\/$/, '');
  if (process.env.NODE_ENV === 'development') return '';
  return prodDefault;
}

/** Empty string in dev = same-origin `/api/*` via setupProxy (no CORS). */
export const API_BASE = resolveApiBase(
  process.env.REACT_APP_API_BASE,
  PROD_API_BASE
);

export const TAVILY_PROXY = resolveApiBase(
  process.env.REACT_APP_TAVILY_PROXY,
  PROD_TAVILY_PROXY
);

export const MAX_FILE_BYTES = 10 * 1024 * 1024;
export const MAX_ATTACHMENTS = 3;
export const MAX_FIRESTORE_MSG_BYTES = 900_000;
export const USAGE_WARN_USD = 1.0;

export const APP_NAME = 'Oberoi AI';
export const APP_VERSION = '1';
export const APP_AUTHOR = 'Shivesh Sharma';

export function getAppDisclaimer() {
  return `Oberoi is currently in its testing/experimental phase. Do not share any private information due to privacy & security reasons. Oberoi can make mistakes. Max ${MAX_ATTACHMENTS} files, ${MAX_FILE_BYTES / (1024 * 1024)}MB each.`;
}
